/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Cannot_Add_PlayersInputs */



/**
* | output |
* | --- |
* | "Cannot add players in this state" |
*
* @param {Err_Tournament_Cannot_Add_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_cannot_add_players = /** @type {((inputs?: Err_Tournament_Cannot_Add_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Cannot_Add_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'ajouter des joueurs dans cet état")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pueden añadir jugadores en este estado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não é possível adicionar jogadores neste estado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile aggiungere giocatori in questo stato")
	return /** @type {LocalizedString} */ ("Cannot add players in this state")
});